export default __webpack_public_path__ + "static/media/dilution1.3db40d88.jpg";